export const rem = Number.parseFloat(document.documentElement.style.fontSize);

